export default __webpack_public_path__ + "static/media/countDown_watch.41bd7232.svg";